<template lang="pug">
    label(:for="formId")
      |{{ label }}
      span.error-msg {{ " " + errorMessage }}
</template>

<script>
export default {
  name: "FormLabel",
  props: {
    formId: { type: String, required: true },
    label: { type: String, required: true },
    errorMessage: { type: String }
  }
};
</script>

<style lang="scss" scoped>
label {
  display: inline-block;
  margin-bottom: 10px;
}
</style>
